import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Scroll-linked parallax image with hover zoom. scale-115 keeps edges covered during parallax drift.
export const ParallaxImage = ({ webp, src, alt, imgClassName = "aspect-[4/3]", className = "", speed = 28, testId }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], [-speed, speed]);
    return (
        <div ref={ref} data-testid={testId} className={`group overflow-hidden rounded-md ${className}`}>
            <motion.div style={{ y }} className="will-change-transform">
                <picture>
                    {webp ? <source srcSet={webp} type="image/webp" /> : null}
                    <img
                        src={src}
                        alt={alt}
                        loading="lazy"
                        decoding="async"
                        className={`w-full scale-[1.15] object-cover transition-transform duration-700 group-hover:scale-[1.22] ${imgClassName}`}
                    />
                </picture>
            </motion.div>
        </div>
    );
};

export default ParallaxImage;
